import { NexiaBasketObject } from "../../models/nexia-basket-object";
import { SignatureImageFile } from '../../models/signature-image-file';

export class  UserPreferenceLocalStorage{
    nexiaBasketState : {[key: string]: NexiaBasketObject[]};
    recentFileTemplates: string[] = [];
    signatureImageFile: SignatureImageFile;
}